import { reactive } from "vue";

export const DEEP_VIEWS = ["competitors", "citations", "prompts", "sentiment", "crawlers"];

export const shell = reactive({
  navOpen: false,
  deepOpen: false,
  wbTwoCol: false,
});

try {
  shell.deepOpen = localStorage.getItem("soa_deep") === "1";
} catch (_) {
  /* ignore */
}

export function closeNav() {
  shell.navOpen = false;
}

export function toggleNav() {
  shell.navOpen = !shell.navOpen;
}

export function toggleDeep(force) {
  if (force === true) shell.deepOpen = true;
  else if (force === false) shell.deepOpen = false;
  else shell.deepOpen = !shell.deepOpen;
  try {
    localStorage.setItem("soa_deep", shell.deepOpen ? "1" : "0");
  } catch (_) {
    /* ignore */
  }
}
